export default "https://client.chat.ao.com/1289/beta/without-externals/assets/sounds/newMessage.webm?c57c1618457c9744b2fb725c369b105b";